'use client';

import { c as _c } from "react/compiler-runtime";
import type { ActivityLanguage, ActivityVariant } from '@funkey/types/graphql/graphql';
import { FormInputErrors, InputSelect } from '~/components/primitives';
import { FormLabel } from '~/components/primitives';
import { useI18n } from '~/features/i18n';
import type useQuotationCardFormState from './useQuotationCardFormState';
export default function CartItemFormFields(t0) {
  const $ = _c(62);
  const {
    formState,
    variants: t1,
    languages: t2
  } = t0;
  let t3;
  if ($[0] !== t1) {
    t3 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const variants = t3;
  let t4;
  if ($[2] !== t2) {
    t4 = t2 === undefined ? [] : t2;
    $[2] = t2;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const languages = t4;
  const i18n = useI18n();
  if (variants.length === 1 && !formState.values.variantId) {
    formState.handleChange("variantId", Number(variants[0].id));
  }
  if (languages.length === 1 && !formState.values.languageId) {
    formState.handleChange("languageId", Number(languages[0].id));
  }
  let t5;
  if ($[4] !== i18n) {
    t5 = i18n._("Variant");
    $[4] = i18n;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t5) {
    t6 = <FormLabel htmlFor="variantId" size="md" className="w-25">{t5}</FormLabel>;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const t7 = variants.length === 1 && !!formState.values.variantId;
  let t8;
  if ($[8] !== i18n) {
    t8 = i18n._("Select variant");
    $[8] = i18n;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  const t9 = formState.values.variantId != null ? String(formState.values.variantId) : "";
  let t10;
  if ($[10] !== formState) {
    t10 = formState.getErrorMessages("variantId");
    $[10] = formState;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  const t11 = t10.length > 0;
  let t12;
  if ($[12] !== variants) {
    t12 = variants.map(_temp);
    $[12] = variants;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  if ($[14] !== formState) {
    t13 = value => formState.handleChange("variantId", Number(value));
    $[14] = formState;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  let t14;
  if ($[16] !== t11 || $[17] !== t12 || $[18] !== t13 || $[19] !== t7 || $[20] !== t8 || $[21] !== t9) {
    t14 = <InputSelect id="variantId" className="w-full overflow-hidden" readonly={t7} compact={true} placeholder={t8} value={t9} hasError={t11} options={t12} onChange={t13} />;
    $[16] = t11;
    $[17] = t12;
    $[18] = t13;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== t14 || $[24] !== t6) {
    t15 = <div className="flex flex-row items-center gap-5">{t6}{t14}</div>;
    $[23] = t14;
    $[24] = t6;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== formState) {
    t16 = formState.getErrorMessages("variantId");
    $[26] = formState;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== t16) {
    t17 = <FormInputErrors errors={t16} className="text-right" />;
    $[28] = t16;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  if ($[30] !== t15 || $[31] !== t17) {
    t18 = <div className="flex flex-col gap-2">{t15}{t17}</div>;
    $[30] = t15;
    $[31] = t17;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  let t19;
  if ($[33] !== i18n) {
    t19 = i18n._("Language");
    $[33] = i18n;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  let t20;
  if ($[35] !== t19) {
    t20 = <FormLabel htmlFor="variantId" size="md" className="w-25">{t19}</FormLabel>;
    $[35] = t19;
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  let t21;
  if ($[37] !== i18n) {
    t21 = i18n._("Select language");
    $[37] = i18n;
    $[38] = t21;
  } else {
    t21 = $[38];
  }
  const t22 = formState.values.languageId != null ? String(formState.values.languageId) : "";
  let t23;
  if ($[39] !== formState) {
    t23 = formState.getErrorMessages("languageId");
    $[39] = formState;
    $[40] = t23;
  } else {
    t23 = $[40];
  }
  const t24 = t23.length > 0;
  let t25;
  if ($[41] !== formState) {
    t25 = value_0 => formState.handleChange("languageId", Number(value_0));
    $[41] = formState;
    $[42] = t25;
  } else {
    t25 = $[42];
  }
  let t26;
  if ($[43] !== languages || $[44] !== t21 || $[45] !== t22 || $[46] !== t24 || $[47] !== t25) {
    t26 = <InputSelect id="languageId" className="w-full" compact={true} placeholder={t21} options={languages} labelField="name" valueField="id" value={t22} hasError={t24} onChange={t25} />;
    $[43] = languages;
    $[44] = t21;
    $[45] = t22;
    $[46] = t24;
    $[47] = t25;
    $[48] = t26;
  } else {
    t26 = $[48];
  }
  let t27;
  if ($[49] !== t20 || $[50] !== t26) {
    t27 = <div className="flex flex-row items-center gap-5">{t20}{t26}</div>;
    $[49] = t20;
    $[50] = t26;
    $[51] = t27;
  } else {
    t27 = $[51];
  }
  let t28;
  if ($[52] !== formState) {
    t28 = formState.getErrorMessages("languageId");
    $[52] = formState;
    $[53] = t28;
  } else {
    t28 = $[53];
  }
  let t29;
  if ($[54] !== t28) {
    t29 = <FormInputErrors errors={t28} className="text-right" />;
    $[54] = t28;
    $[55] = t29;
  } else {
    t29 = $[55];
  }
  let t30;
  if ($[56] !== t27 || $[57] !== t29) {
    t30 = <div className="flex flex-col gap-2">{t27}{t29}</div>;
    $[56] = t27;
    $[57] = t29;
    $[58] = t30;
  } else {
    t30 = $[58];
  }
  let t31;
  if ($[59] !== t18 || $[60] !== t30) {
    t31 = <div className="grid grid-cols-1 gap-5">{t18}{t30}</div>;
    $[59] = t18;
    $[60] = t30;
    $[61] = t31;
  } else {
    t31 = $[61];
  }
  return t31;
}
function _temp(t0) {
  const {
    id,
    name
  } = t0;
  return {
    value: id,
    label: name
  };
}